import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { feedbackService } from '@/services/feedbackService';
import type { FeedbackFilters } from '@/types/feedback';

export function useFeedbacks(filters: FeedbackFilters = {}) {
  return useQuery({
    queryKey: ['admin', 'feedbacks', filters],
    queryFn: () => feedbackService.getFeedbacks(filters),
  });
}

export function useFeedback(id: string) {
  return useQuery({
    queryKey: ['admin', 'feedback', id],
    queryFn: () => feedbackService.getFeedback(id),
    enabled: !!id,
  });
}

export function useDeleteFeedback() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => feedbackService.deleteFeedback(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'feedbacks'] });
    },
  });
}
